import axios from 'axios';
import { constants } from './constants';

const instantiateConfig = () => {
  axios.defaults.baseURL = constants.baseURL;
};

export default instantiateConfig;
